import React, { useContext, useState, useEffect } from "react";
import convertRupiah from "rupiah-format";
import { UserContext } from "../../context/userContext";
import { useQuery } from "react-query";
import { API } from "../../config/api";
import dateFormat from "dateformat";

import Navigasi from "../../components/Navigasi";
import logo from "../../assets/img/hero-image.png";
import profilePhoto from "../../assets/img/photo.jpeg";

function MyProfile() {
  document.title = "My Profile";

  const [state] = useContext(UserContext);

  useEffect(() => {
    console.log("Load State");
  }, [state]);

  let { data: transactions, refetch: transactionsRefetch } = useQuery(
    "transactionsCache",
    async () => {
      const config = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const response = await API.get("/transactions", config);
      return response.data.data;
    }
  );

  return (
    <>
      <Navigasi active="myProfile" />
      <div className="container myprofile-section">
        <div className="row">
          <div className="col-md-6 detail-profile">
            <div className="row">
              <div className="col-md-6">
                <img src={profilePhoto} alt="profile" className="img-fluid" />
              </div>
              <div className="col-md-6">
                <p className="name-profile">Name</p>
                <p className="mb-4">{state.user.name}</p>

                <p className="email-profile">Email</p>
                <p className="mb-4">{state.user.email}</p>

                <p className="phone-profile">Phone</p>
                <p className="mb-4">{state.user.phone}</p>

                <p className="gender-profile">Gender</p>
                <p className="mb-4">{state.user.gender}</p>

                <p className="address-profile">Address</p>
                <p className="mb-4">{state.user.address}</p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <p className="my-transaction-title">My Transaction</p>

            <div className="card-cart-profile">
              {transactions?.length !== 0 ? (
                <>
                  {transactions?.map((item) => (
                    <div className="row p-3">
                      <div className="col-md-8 d-flex justify-content-center align-items-center">
                        <div className="row">
                          <div className="col-md-4">
                            <img
                              src={item.Product.image}
                              alt="product"
                              className="img-fluid"
                            />
                          </div>
                          <div className="col-md-8 detail-transaction">
                            <p className="fw-bold product-name">
                              {item.Product.name}
                            </p>
                            <p className="product-date">
                              {dateFormat(
                                item.createdAt,
                                "dddd, d mmmm yyyy, HH:MM "
                              )}
                              WIB
                            </p>
                            <p className="product-price">
                              Price: {convertRupiah.convert(item.price)}
                            </p>
                            <p className="product-subtotal">
                              Status:
                              {item.status === "success" ? (
                                <span className="alert-success mx-2 p-1 rounded">
                                  {item.status}
                                </span>
                              ) : (
                                <span className="alert-warning mx-2 p-1 rounded">
                                  {item.status}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 d-flex justify-content-center align-items-center">
                        <img
                          src={logo}
                          alt="logo"
                          className="img-fluid"
                          style={{ height: "50%" }}
                        />
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <div className="no-data-transaction">No transaction</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyProfile;
